(function () {
  $("#submit-btn").click(function () {
    submitUpdate();
  });

  function submitUpdate() {
    
    const customerId = $('#customer').data('id');
    const birthday = $('#birthday').val();
    const housing_type = $('#housingType').val();
    const house_size = $('#houseSize').val();

    const metafields = [];

    if (birthday) {
      metafields.push({ namespace: 'custom', key: 'birthday', value: birthday, type: 'date' });
    }

    if (housing_type) {
      metafields.push({ namespace: 'custom', key: 'housing_type', value: housing_type, type:'single_line_text_field' });
    }

    if (house_size) {
      metafields.push({ namespace: 'custom', key: 'house_size', value: house_size, type:'single_line_text_field' });
    }


    $.ajax({
      url: 'https://mopio-shopify.castlery.com/customer',
      type: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        "type": "mutation",
        "module": "customer:metafields",
        "customerId": customerId,
        "payload": {
          "metafields": metafields
        }
      }),
      success: function (response) {
        if (response.code === 0) {
          alert('update success!');
          location.replace('/account');
        } else {
          alert(`update failed: ${response.message}`);
        }
      },
      error: function (error) {
        const errorMessage = error.responseJSON.message;
        const trimmedErrorMessage = errorMessage.trim();
        alert(`update failed: ${trimmedErrorMessage}`);
      }
    });


  }

})();